<template>
  <div
    class="presentation"
    :class="{
      'white': isTextColourLight,
      'slide-text-left': slideActive.textAlign == 'left',
      'slide-text-right': slideActive.textAlign == 'right',
      'slide-text-center': slideActive.textAlign == 'center',
      'enable-audio-control': slideActive.audioAudienceShowControl,
      'waiting-for-next-slide': dataSlideNext && dataSlideNext.id,
    }"
  >
    <LostConnection
      v-if="showLostConnection"
    />
    <div class="loading-screen horizontal layout center center-justified" v-if="isLoading">
      <Loading v-if="isLoading || isLoadingFeatures" />
    </div>
    <router-view />

    <div class="tabs-content" :class="{'tabs-content-hackathon': slideActive.type === 'hackathon-slide'}">
      <div v-if="$store.state.activeTabView === 'slide'" class="hackathon-slide">
        <Logo />
        <div v-if="slideActive.type !== 'hackathon-slide'">
          <div v-if="!$store.state.presentation.privateMode">
            <div
              class="content-presentation"
              v-if="!isLoading && !limitOnline"
              :class="{'is-content-slide': slideActive.type === 'freestyle'}"
            >
              <div
                v-if="isLoadNextSlide"
                class="text-center padding horizontal layout center center-justified loading-slide-data"
              >
                <Loading />
              </div>

              <AudienceAdmissionForm v-if="isEnableAudienceAdmissionForm" />

              <div v-if="!isEnableAudienceAdmissionForm">
                <div v-if="!slideActive.isEndSlide">
                  <MultipleChoiceContent
                    v-if="slideActive.type == 'multipleChoice'
                      || slideActive.type == 'imageChoice'
                      || slideActive.type == 'scale'"
                  />
                  <QuestionContent v-if="slideActive.type == 'question'" />
                  <OpenEndedContent v-if="slideActive.type == 'openEnded'" />
                  <IdeasContent v-if="slideActive.id && slideActive.type === 'ideas'" />

                  <TextSlideContent
                    v-if="slideActive.id && slideActive.type == 'textSlide'"
                  />
                  <TextSlideContent
                    v-if="slideActive.id && slideActive.type == 'bulletPoints'"
                  />
                  <FreestyleContent v-if="slide.id && slide.type == 'freestyle'" />
                  <QRCodeContent v-if="slideActive.id && slideActive.type == 'qrcode'" />
                  <ImageContent v-if="slideActive.id && slideActive.type == 'image'" />
                  <ImageContent v-if="slideActive.id && slideActive.type == 'document'" />
                  <YoutubeContent v-if="slideActive.id && slideActive.type == 'youtube'" />
                  <EmbedContent v-if="slideActive.id && slideActive.type == 'embed'" />
                  <GoogleSlidesContent
                    v-if="slideActive.id && slideActive.type == 'googleSlides'"
                  />
                  <WordCloudContent
                    v-if="slideActive.id && slideActive.type == 'wordCloud'"
                  />

                  <PickAnswerContent
                    v-if="slideActive.id && slideActive.type == 'pickAnswer'"
                  />

                  <LeaderboardContent
                    v-if="
                      slideActive.id
                        && slideActive.type == 'leaderboard'
                        && !$store.state.presentation.teamPlay
                    "
                  />
                  <LeaderboardTeamContent
                    v-if="
                      slideActive.id
                        && slideActive.type == 'leaderboard'
                        && $store.state.presentation.teamPlay
                    "
                  />
                  <SpinnerWheelContent
                    v-if="slideActive.id && slideActive.type == 'spinnerWheel'"
                  />

                  <QASessionBtn v-if="_checkShowQASessionBtn()" id="presentation-qna-global" />
                  <div
                    class="audience-pacing"
                    v-if="
                      slideActive.id
                        && $store.state.presentation.audiencePacing
                        && showAudiencePacingBtn
                    "
                  >
                    <ui-button
                      block
                      size="lg"
                      variant="outline-dark"
                      v-if="checkLastSlide()"
                      @click="endPresentation()"
                    >
                      {{ $t("finishButton") }}
                    </ui-button>
                  </div>
                </div>
                <SlideWaiting v-if="slideActive.isEndSlide" />

                <div v-if="$store.state.showQaSession" class="box-qna-session">
                  <div class="overlay-qna" @click="hideQASession" />
                  <QASession />
                </div>

                <div
                  v-if="$store.state.showRequestPresentation"
                  class="box-request-presentation vertical layout"
                >
                  <div class="overlay-qna" @click="hideRequestPresentation" />
                  <div class="audience-flex" />
                  <RequestPresentationForm />
                </div>
              </div>

              <AudienceAuthentication
                v-if="enableAudienceAuthentication"
              />
            </div>
            <div class="text-center content-presentation padding" v-if="limitOnline">
              <h3>Participant limit exceeded</h3>
              <p>{{ limitOnline }}</p>
            </div>
          </div>

          <div class="text-center padding" v-else>
            {{ $t("presentationIsNotOpen") }}
            <div class="try-to-reload">
              {{ $t("Or try to") }}
              <a
                class="link-reload"
                @click="reloadPage()"
                :class="{'white': isTextColourLight, 'private-mode' :$store.state.presentation.privateMode}"
              >
                {{ $t("reloadTextLink") }}
              </a>
            </div>
          </div>
        </div>
        <div
          v-if="slideActive.type === 'hackathon-slide' && (!audienceId || !audienceName || !audienceEmoji)"
          style="padding: 0 16px;"
        >
          <QuizJoinGameForm />
        </div>

        <HackathonSlideContent v-if="slideActive.type === 'hackathon-slide' && audienceId && audienceName && audienceEmoji" :key="`hackathon-${slideActive.id}`" />

        <div :class="{'reaction-hackathon': slideActive.type === 'hackathon-slide'}">
          <ReactionsV2 v-if="isReactionsV2Visible" />
          <Reactions v-else-if="isReactionsVisible" />
          <AudiencePacingNavigation
            v-if="presentation.audiencePacing"
            :presentation="presentation"
            :isDisabledBackButton="currentSlideIndex === 0"
            :isDisabledNextButton="isDisabledNextButton"
            :currentSlideIndex="currentSlideIndex"
            :totalSlides="totalSlides"
            :nextSlideHandler="selfPaceNextSlide"
            :backSlideHandler="selfPacePrevSlide"
          />
        </div>
      </div>
      <OpenLinkModal v-if="showHyperLinkModal" :url="clickedUrl" @hide="hide" />
    </div>

    <VoiceCallAlert
      v-if="$store.state.voiceCall.isOpen && $store.state.voiceCall.status === 'waiting-accept'"
    />
    <VoiceCallView
      v-if="$store.state.voiceCall.isOpen && $store.state.voiceCall.status === 'during-call'"
    />
    <div
      class="aha-footer__live-chat"
      :class="{'custom-d-none': !isAudienceEmojiDisabled}"
      v-if="isLiveChatVisible"
    >
      <LiveChat class="live-chat__wrapper" :openByDefault="isQuizLobby" />
    </div>

    <PresentationAudio v-if="canInjectPresentationAudio" />
  </div>
</template>

<script>
// @ is an alias to /src
import _throttle from 'lodash/throttle'
import get from 'lodash/get'
import { setTimeout } from 'timers'
import * as Sentry from '@sentry/vue'
import { mapState, mapActions, mapGetters } from 'vuex'
import Vue from 'vue'
import Config from '@/config'
import Util from '@/util'
import Loading from '@/components/Loading'
import Logo from '@/components/Logo'
import MultipleChoiceContent from '@/components/types/MultipleChoiceContent.vue'
import OpenEndedContent from '@/components/types/OpenEndedContent'
import TextSlideContent from '@/components/types/TextSlideContent'
import FreestyleContent from '@/components/types/FreestyleContent'
import QRCodeContent from '@/components/types/QRCodeContent'
import ImageContent from '@/components/types/ImageContent'
import YoutubeContent from '@/components/types/YoutubeContent'
import GoogleSlidesContent from '@/components/types/GoogleSlidesContent'
import WordCloudContent from '@/components/types/WordCloudContent'
import PickAnswerContent from '@/components/types/PickAnswerContent'
import QASession from '@/components/QASession'
import RequestPresentationForm from '@/components/footer/RequestPresentationForm'
import QASessionBtn from '@/components/QASessionBtn'
import LeaderboardContent from '@/components/types/LeaderboardContent'
import LeaderboardTeamContent from '@/components/types/LeaderboardTeamContent'
import QuestionContent from '@/components/types/QuestionContent'
import LostConnection from '@/components/LostConnection'
import storage from '@/services/storage'
import SpinnerWheelContent from '@/components/types/SpinnerWheelContent.vue'
import SpinnerWheelContainer from '@/containers/spinner-wheel/SpinnerWheel'
import IdeasContent from '@/components/types/IdeasContent.vue'
import AudienceAdmissionForm from '@/components/AudienceAdmissionForm.vue'
import VoiceCallAlert from '@/components/voice-call/VoiceCallAlert.vue'
import VoiceCallView from '@/components/voice-call/VoiceCallView.vue'
import AudienceAuthentication from '@/components/audienceAuthentication/AudienceAuthentication.vue'
import PresentationAudio from '@/components/PresentationAudio.vue'
import OpenLinkModal from '@/components/modals/openLinkModal.vue'
import SlideWaiting from '@/components/SlideWaiting'
import HackathonSlideContent from '@/components/HackathonSlideContent.vue'
import EmbedContent from '@/components/types/EmbedContent.vue'

// UI
import UiButton from '@/components/UI/Button'

import socket from '@/socket'
import EventBus from '@/eventBus'
import QuizStatuses from '@/constants/QuizStatuses'
import SelfPacedQuiz from '@/services/SelfPacedQuiz'
import Audience from '@/classes/audience'

// 3rd parties
import sentry from '@/3rd-parties/sentry'
import Reactions from '@/components/reactions/Reactions.vue'
import ReactionsContainer from '@/containers/reactions/Reactions'
import ReactionsV2 from '@/components/reactions/ReactionsV2.js'
import LiveChat from '@/components/common/LiveChat.vue'
import constants from '@/constant'
import preloadFont from '@/utils/font.preloader'
import SelfPaceMixin from '@/mixins/SelfPaceMixin'
// load css third party

import 'emoji-mart-vue-fast/css/emoji-mart.css'
import '@/assets/scss/animate2.css'
import '@/assets/scss/filestack.custom.scss'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'
import 'vue-glide-js/dist/vue-glide.css'
// vue use

import VuejsDialog from 'vuejs-dialog'
import VueGlide from 'vue-glide-js'
import Toasted from 'vue-toasted'
import PresentationSocketHandlerV2 from '@/utils/presentationSocketHandler.v2'
import { detectSafari } from '@/utils/dom.utils'

// api
import presentationAudienceLatency from '@/api/presentation-audience-latency'

import joinPresentationUtils from '@/utils/join-presentation.utils'
import QuizJoinGameForm from '@/components/QuizJoinGameForm.vue'

Vue.use(VuejsDialog)
Vue.use(VueGlide)
Vue.use(Toasted, {
  duration: 3000,
  singleton: true,
})
sentry.init()

const PAGE_TITLE = 'Live Audience Engagement Platform - AhaSlides'

export default {
  name: 'Presentation',
  components: {
    LiveChat,
    Reactions: ReactionsContainer(Reactions),
    ReactionsV2,
    SlideWaiting,
    SpinnerWheelContent: SpinnerWheelContainer(SpinnerWheelContent),
    AudienceAdmissionForm,
    Loading,
    Logo,
    UiButton,
    MultipleChoiceContent,
    OpenEndedContent,
    TextSlideContent,
    FreestyleContent,
    QRCodeContent,
    ImageContent,
    YoutubeContent,
    GoogleSlidesContent,
    WordCloudContent,
    PickAnswerContent,
    LeaderboardContent,
    QASession,
    QASessionBtn,
    QuestionContent,
    LostConnection,
    LeaderboardTeamContent,
    IdeasContent,
    RequestPresentationForm,
    VoiceCallAlert,
    VoiceCallView,
    AudienceAuthentication,
    PresentationAudio,
    OpenLinkModal,
    AudiencePacingNavigation: () => import('@/components/AudiencePacingNavigation.vue'),
    HackathonSlideContent,
    QuizJoinGameForm,
    EmbedContent,
  },
  mixins: [SelfPaceMixin],
  data() {
    return {
      uniqueAccessCode: '',
      isLoading: true,
      dataSlideNext: null,
      isConnectSocket: false,
      isLoadNextSlide: false,
      presenterUrl: '',
      limitOnline: '',
      currentDataBulletPoint: null,
      clickedUrl: '',
      lastMqttUpdateSlideTimestamp: null,
    }
  },

  computed: {
    ...mapGetters('presentationSettings', [
      'isEnableAudienceAdmissionForm',
    ]),
    ...mapGetters('liveStatsV2', [
      'canSubscribeReactionEmqx',
    ]),
    ...mapGetters('featureToggles', [
      'isLoadingFeatures',
      'canUseNewChangeSlideMechanism',
      'showConnectionStatus',
      'enableForBigEvent',
    ]),
    ...mapGetters({
      slideActive: 'activeActivity',
    }),
    ...mapGetters('themeModule', ['isTextColourLight']),
    ...mapState({
      audienceId: (state) => state.audienceId,
      audienceEmail: (state) => state.audienceEmail,
      audienceEmoji: (state) => state.audienceEmoji,
      authenticationCode: (state) => state.authenticationCode,
      audienceName: (state) => state.audienceName,
      presentation: (state) => state.presentation,
      currentDataNextSlide: (state) => state.currentDataNextSlide,
      isPresenting: (state) => state.presentation.presenting,
      isAudienceEmojiDisabled: (state) => state.isAudienceEmojiDisabled,
      audienceTeam: (state) => {
        return state.presentation.teamData ?
          state.presentation.teamData.find((team) => team.id === state.audienceQuizTeam) : {}
      },
      currentUser: (state) => state.currentUser,
      userLoaded: (state) => state.userLoaded,
      slides: (state) => state.slides,
      slidesList: (state) => state.slidesList,
      offsetTime: (state) => state.offsetTime,
      numberTrackingPercent: (state) => state.numberTrackingPercent,
    }),

    showHyperLinkModal() {
      return this.clickedUrl
    },

    isUserAndPresentationLoaded() {
      return this.currentUser
        && this.currentUser.id
        && this.presentation
        && this.presentation.id
    },

    slideListLoaded() {
      return this.slides && this.slides.length
    },

    canInjectPresentationAudio() {
      if (!this.presentation || !this.presentation.audiencePacing) return false

      if (!this.presentation.audioLink) return false

      if (Config.env === 'production') {
        return this.presentation.userId === 1305929 // cnf
      }

      if (Config.env === 'develop') {
        return this.presentation.userId === 3140 // sh
      }

      return true
    },

    showAudiencePacingBtn() {
      const { type } = this.slide
      if (type === 'multipleChoice' || type === 'imageChoice') {
        return false
      }
      return true
    },
    enableAudienceAuthentication() {
      const { isAudienceAuthentication } = this.presentation
      if (isAudienceAuthentication && !this.authenticationCode) {
        return true
      }
      return false
    },
    hasAudienceInfo() {
      const hasSoloInfo = this.audienceName.length !== 0 && this.audienceId
      if (this.presentation.teamPlay && this.audienceTeam && this.audienceTeam.name) {
        return this.audienceTeam.name.length !== 0 && hasSoloInfo
      }
      return hasSoloInfo
    },

    isLiveChatVisible() {
      return this.presentation.isEnableChat &&
        !this.presentation.audiencePacing &&
        !this.presentation.privateMode &&
        !this.isEnableAudienceAdmissionForm &&
        this.hasAudienceInfo &&
        this.isPresenting &&
        this.isQuizLobby
    },

    hasQuizSlides() {
      return this.$store.state.slides &&
          this.$store.state.slides.length > 0 &&
          this.$store.state.slides.some((slide) => slide.type === 'pickAnswer')
    },

    isQuizLobby() {
      const { type, quizStatus } = this.slideActive
      return type === 'pickAnswer' &&
        quizStatus === QuizStatuses.LOBBY_SCREEN
    },

    isReactionsVisible() {
      return !this.presentation.privateMode && this.slideActive.id
      && !['feedback', 'lookback', 'profile'].includes(this.$store.state.activeTabView)
    },
    isReactionsV2Visible() {
      return this.presentation.id && this.canSubscribeReactionEmqx && this.isReactionsVisible
    },
    canShowSlideProgressBar() {
      return this.presentation.id &&
        !this.isSortSlide && !this.presentation.audiencePacing
    },

    currentSlideIndex() {
      if (!this.slides || !this.slide) {
        return 0
      }
      return this.slides.findIndex((item) => {
        return item.id === this.slideActive.id
      })
    },

    totalSlides() {
      if (!this.slides || !this.slide) {
        return 0
      }
      return this.slides.length
    },

    canShowSkipToNextSlideButton() {
      return !this.presentation.audiencePacing && !this.checkLastSlide() && this.checkTextSkip()
    },

    isDisabledNextButton() {
      if (!this.slides || !this.slide) {
        return true
      }
      if (this.currentSlideIndex === this.totalSlides - 1) {
        return true
      }
      return false
    },
    showLostConnection() {
      return !this.showConnectionStatus &&
        (this.$store.state.socketDisconnect || this.$store.state.connectionError)
    },
  },
  watch: {
    userLoaded: function watchUserLoaded(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.loadDataPresentation()
      }
    },
    'slideActive.id': {
      handler(value) {
        this.handleSlideIdChange(value)
      },
      immediate: true,
    },
  },
  created() {
    this.loadOpenTok()
    this.loadFont()
  },

  mounted() {
    window.addEventListener('popstate', this.popStateHandler)
    this.registerHyperLinkListener()

    this.presenterUrl = Config.presenterUrl
    this.uniqueAccessCode = this.$route.params.id
    if (this.userLoaded) {
      this.loadDataPresentation()
    }
    EventBus.$on('confirmNextSlide', (id) => {
      if (id) {
        this.dataSlideNext = {}
        this.dataSlideNext.id = id
      }

      if (
        this.dataSlideNext
        && this.dataSlideNext.id
        && this.dataSlideNext.id !== this.slideActive.id
      ) {
        this.confirmNextSlide()
      } else {
        SelfPacedQuiz.playSelfPacedQuizSlide(this.presentation, this.slide)
      }
    })

    EventBus.$on('skipSlide', () => {
      this.audienceChangeSlide()
    })

    detectSafari()
  },
  destroy() {
    socket.unSubscribe(this.uniqueAccessCode.toLowerCase())
    socket.close()
    EventBus.$off('confirmNextSlide')
    EventBus.$off('skipSlide')
    window.removeEventListener('popstate', this.popStateHandler)
    this.unregisterHyperLinkListener()
    this.unsubscribeSlideChangeAction(this.presentation)
  },
  methods: {
    ...mapActions([
      'setAudienceIdAction',
      'patchPresentationAction',
      'createOrUpdateAudienceAction',
      'setPresentationAction',
      'setSlide',
      'setSlideIndexAction',
      'getPresentationByCode',
    ]),
    ...mapActions('featureToggles', ['updateFeatureContext']),
    ...mapActions('presentationAttributeModule', ['getPresentationAttributeAction']),
    ...mapActions('nextback', ['subscribeSlideChangeAction', 'unsubscribeSlideChangeAction', 'getSlideAction', 'syncQuizStageAction']),
    ...mapActions('leaderboard', ['subscribeLeaderboardVisibilityAction']),
    ...mapActions('quiz', [
      'subscribeQuizResponseAction',
    ]),
    registerHyperLinkListener() {
      document.addEventListener('click', this.handleClickLink)
    },
    uregisterHyperLinkListener() {
      document.removeEventListener('click', this.handleClickLink)
    },
    handleClickLink(e) {
      const href = get(e, 'target.href', '')
      const cssClass = get(e, 'target.classList[0]', '')
      if (!href || cssClass !== 'text-hyper-link') {
        return
      }
      e.preventDefault()
      this.clickedUrl = href
    },
    hide() {
      this.clickedUrl = ''
    },
    ...mapActions('presentationChat', ['clearChatMessagesAction']),
    loadDataPresentation() {
      this.getPresentationV2()
    },
    async getPresentationV2() {
      if (!this.uniqueAccessCode) {
        this.isLoading = false

        return
      }

      const params = {
        connect: true,
      }

      if (this.$store.state.idSlide) {
        params.idSlide = this.$store.state.idSlide
      }

      let response = null
      try {
        response = await this.getPresentationByCode({ uniqueAccessCode: this.uniqueAccessCode, params })
      } catch (error) {
        Sentry.captureException(error)
        this.isLoading = false
        this.$router.push({
          name: 'home',
          query: { error: true },
        })

        return
      }

      let presentationId = null
      if (response.body.presentation && response.body.presentation.id) {
        presentationId = response.body.presentation.id
      } else {
        presentationId = response.body.id
      }
      await this.getPresentationAttributeAction(presentationId)
      this.handleResetData(response.body)
      await this.setAudienceInfo(presentationId)
      this.onUnleashContextReady(response, params)
    },

    async onUnleashContextReady(response, params) {
      if (response.body.presentation) {
        this._hanldeAudienceGetPresentation(response)
        return
      }

      const urlCdn = response.body.cacheSlideActiveUrl

      try {
        const res = await this.$http.get(urlCdn)
        res.body = this.tryParseBody(res.bodyText, response.body.id)
        res.body.presentation = response.body
        this._hanldeAudienceGetPresentation(res)
        return
      } catch (error) {
        if (Sentry && error.status) {
          error.from = 'Audience get presentation'
          Sentry.captureException(JSON.stringify(error))
        }
      }

      try {
        const dataUnhandle = await this.$http.get(
          Config.api.getPresentation + this.uniqueAccessCode,
          { params },
        )
        this._hanldeAudienceGetPresentation(dataUnhandle)
      } catch (error) {
        if (Sentry && error.status) {
          error.from = 'Audience get presentation unhandle'
          Sentry.captureException(JSON.stringify(error))
        }
      }
    },

    async setAudienceInfo(presentationId) {
      const audienceId = storage.getValueByPresentation(presentationId, 'audienceId', Audience.generateId())
      const audienceName = storage.getValueByPresentation(presentationId, 'audienceName', '')

      const audienceEmail = storage.getValueByPresentation(presentationId, 'audienceEmail', '')
      const audienceTeam = storage.getValueByPresentation(presentationId, 'audienceTeam', '')
      const authenticationCode = storage.getValueByPresentation(presentationId, 'authenticationCode', '')

      await this.setAudienceIdAction(audienceId)

      this.$store.state.audienceName = audienceName
      this.$store.state.audienceEmail = audienceEmail
      this.$store.state.audienceTeam = audienceTeam
      this.$store.state.authenticationCode = authenticationCode

      const isShownEmojiAvatar = this.$store.getters['presentationSettings/isShownEmojiAvatar']
      // get audienceEmoji
      let audienceEmoji = storage.getValueByPresentation(presentationId, 'audienceEmoji')
      if (audienceEmoji) {
        this.$store.state.isAudienceEmojiDisabled = true
      } else {
        audienceEmoji = Util.getRandomEmoji()
      }

      // There is an handle in backend doesn't allow to set the emoji as a blank value.
      // If it's blank, the score calculation won't work.
      // So we set the emoji to a space character. (because in javascript blank string is considered as false)
      // More detail, check calculatePointsAndCreateAnswer method in answer controller in the general-api
      this.$store.state.audienceEmoji = isShownEmojiAvatar ? audienceEmoji : ' '
      this.subscribeQuizResponseAction({
        audienceId,
        // TODO: for future development, will need to send version = this.slide.version to keep track the historical data of the quiz result.
      })
    },

    popStateHandler() {
      this.audienceChangeSlide(true)
    },

    reloadPage() {
      window.location.reload()
    },

    loadFont() {
      Object.keys(constants.fonts).forEach((font) => {
        const fontConfig = constants.fonts[font]
        if (fontConfig.url) {
          preloadFont(fontConfig.url)
        }
      })
    },
    loadOpenTok() {
      const s = document.createElement('script')
      s.type = 'text/javascript'
      s.src = 'https://static.opentok.com/v2/js/opentok.min.js'
      document.body.appendChild(s)
    },

    showqna() {
      this.$store.state.showQaSession = true
      Util.mixpanelTrack(
        'Question And Answer',
        'Audience',
        'Open Ask a question popup',
      )
    },
    _checkShowQASessionBtn() {
      if (
        this.slideActive.type !== 'leaderboard' &&
        this.slideActive.type !== 'pickAnswer' &&
        (this.$store.state.presentation.qnaAllSlide ||
        this.slideActive.type === 'question') &&
        !this.isLoadNextSlide &&
        (!this.slideActive.multipleChoiceStatus ||
          (this.slideActive.multipleChoiceStatus && this.slideActive.multipleChoiceStatus !== 3))
      ) {
        return true
      }
      return false
    },
    checkTextSkip() {
      if (
        this.slideActive.type === 'wordCloud' ||
        this.slideActive.type === 'multipleChoice' ||
        this.slideActive.type === 'openEnded' ||
        this.slideActive.type === 'imageChoice' ||
        this.slideActive.type === 'ideas'
      ) {
        return true
      }
      if (this.slideActive.type === 'pickAnswer') {
        return false
      }

      return false
    },
    isShowNextButton() {
      // Keep the old Next button for current slide types, except the Quiz (type == 'pickAnswer') and Leaderboard
      return !this.checkTextSkip() && this.slideActive.type !== 'pickAnswer' && this.slideActive.type !== 'leaderboard'
    },
    endPresentation() {
      this.slideActive.isEndSlide = true
      this.$store.dispatch('updateSlide', this.slideActive)
    },
    checkLastSlide() {
      if (this.presentation && this.presentation.audiencePacing) {
        return false
      }

      const index = this.$store.state.slides.findIndex((item) => {
        return item.id === this.slideActive.id
      })

      if (index !== -1 && index === this.$store.state.slides.length - 1) {
        return true
      }

      return false
    },
    checkAudiencePacing() {
      this.slideActive.isEndSlide = false
      const currentSlideIndex = Util.getCurrentSlideIndexFromUrl()

      if (typeof currentSlideIndex === 'number' &&
        this.$store.state.slides.length &&
        this.$store.state.presentation &&
        this.$store.state.presentation.audiencePacing
      ) {
        if (currentSlideIndex < this.$store.state.slides.length) {
          this.$store.state.idSlide = this.$store.state.slides[currentSlideIndex].id
          this.confirmNextSlide()
        } else {
          const path = `${window.location.pathname}#1`
          window.history.pushState({}, PAGE_TITLE, path)
          this.$store.state.idSlide = this.$store.state.slides[0].id
          this.confirmNextSlide()
        }
      }
    },
    audienceChangeSlide(isFromPopState) {
      if (!this.$store.state.slides.length) return
      const currentSlideIndex = this.$store.state.slides.findIndex((item) => {
        return item.id === this.slideActive.id
      })

      let nextIndexFromStateChange
      let isPrev
      if (isFromPopState) { // clicking either back or forward btn or changing hash directly
        nextIndexFromStateChange = Util.getCurrentSlideIndexFromUrl()
        if (nextIndexFromStateChange === currentSlideIndex
        || nextIndexFromStateChange > this.$store.state.slides.length - 1) return
        isPrev = nextIndexFromStateChange < currentSlideIndex
      } else { // by clicking the next button
        isPrev = false
      }

      if (currentSlideIndex !== -1) {
        if (currentSlideIndex === 0 && isPrev) return
        const shouldPushState = !isFromPopState && !isPrev
        let idSlide // next Slide to fetch data for

        if (!isPrev) { // switching to next slide
          if (currentSlideIndex !== this.$store.state.slides.length - 1) {
            const indexToGo = isFromPopState ? nextIndexFromStateChange : currentSlideIndex + 1
            idSlide = this.$store.state.slides[indexToGo].id
            this.moveToNextSlide(idSlide, indexToGo, isPrev, shouldPushState)
          } else {
            this.slideActive.isEndSlide = true
          }
        } else if (isPrev) {
          if (currentSlideIndex !== 0) {
            const indexToGo = isFromPopState ? nextIndexFromStateChange : currentSlideIndex - 1
            idSlide = this.$store.state.slides[indexToGo].id
            this.moveToNextSlide(idSlide, indexToGo, isPrev, shouldPushState)
          }
        }
      }
    },

    moveToNextSlide(idSlide, nextSlideIndex, isPrev, shouldPushState) {
      this.$store.state.idSlide = idSlide
      this.confirmNextSlide()
      const path = `${window.location.pathname}#${nextSlideIndex + 1}`

      if (!isPrev) {
        if (shouldPushState) window.history.pushState({}, PAGE_TITLE, path)
        Util.mixpanelTrack('Audience', 'Audience Pacing > Next Slide', this.uniqueAccessCode, idSlide)
      } else {
        Util.mixpanelTrack('Audience', 'Audience Pacing > Previous Slide', this.uniqueAccessCode, idSlide)
      }
    },

    confirmNextSlide() {
      // should maintain the text colour of the last slide
      // in order to show the correct logo loader
      if (this.isLoadingFeatures) {
        return
      }

      const emptySlide = {
        id: null,
        textColour: this.slideActive.textColour,
      }
      if (this.currentDataNextSlide) {
        emptySlide.timestamp = this.currentDataNextSlide.timestamp
      }
      this.isLoadNextSlide = true
      this.setSlide(emptySlide)

      if (
        this.$store.state.presentation.audiencePacing &&
        this.$store.state.idSlide
      ) {
        this.dataSlideNext = {
          id: this.$store.state.idSlide,
        }
      }
      if (!this.dataSlideNext) return
      const idNextSlide = this.dataSlideNext.id

      this.$store.state.isLoadNextSlide[idNextSlide] = true
      const _handleGetSlideData = () => {
        const respPromise = async () => {
          if (this.canUseNewChangeSlideMechanism) {
            const slide = await this.getSlideAction(idNextSlide)
            return {
              body: slide,
            }
          }
          return this.$http.get(Config.api.getNextSlide + idNextSlide)
        }
        respPromise()
          .then((res) => {
            if (this.canUseNewChangeSlideMechanism) {
              if (res.body.id !== this.$store.state.nextback.activeSlideId) {
                /**
                 * Preventing race condition: when this promise resolves slower than the speed of slide changed,
                 * we will stop its UI rendering
                 */
                return false
              }
            }
            if (emptySlide.timestamp && this.currentDataNextSlide && emptySlide.timestamp < this.currentDataNextSlide.timestamp) {
              return false
            }
            this.isLoadNextSlide = false
            this.$store.state.isLoadNextSlide[idNextSlide] = false
            res.body = Util.formatSlide(res.body)
            this.$store.dispatch('setSlide', res.body)
            SelfPacedQuiz.playSelfPacedQuizSlide(this.presentation, res.body)
            this.dataSlideNext = null
            return true
          })
          .catch((error) => {
            Sentry.captureException(error)
            this.isLoadNextSlide = false
            this.$store.state.isLoadNextSlide[idNextSlide] = false
          })
      }

      // Only get from cache when presenting and presenter-pacing and having slideCacheUrl
      if (this.dataSlideNext.slideCacheUrl && this.presentation.presenting && !this.presentation.audiencePacing) {
        const url = this.dataSlideNext.slideCacheUrl
        const dataSlideNextTemp = this.dataSlideNext
        this.$http.get(url)
          .then(async (res) => {
            if (emptySlide.timestamp && this.currentDataNextSlide && emptySlide.timestamp < this.currentDataNextSlide.timestamp) {
              return false
            }
            const shouldTrackingLatency = this.numberTrackingPercent < constants.TRACKING_SAMPLE_RATE &&
              this.presentation.presenting && dataSlideNextTemp.clientTimestamp
            if (shouldTrackingLatency) {
              presentationAudienceLatency.createPresentationAudienceLatency({
                ...dataSlideNextTemp,
                action: 'nextSlide',
                stage: 'audience loaded',
                actor: 'audience',
                totalCost: Util.getcurTimeStamp() - dataSlideNextTemp.clientTimestamp,
                presentationId: this.presentation.id,
                audienceId: this.audienceId,
                audienceOffsetTime: this.offsetTime,
                audienceTimestamp: Util.getTimeStamp(),
              })
            }
            res.body = this.tryParseBody(res.bodyText, this.$store.state.presentation.id)
            this.isLoadNextSlide = false
            this.$store.state.isLoadNextSlide[idNextSlide] = false
            res.body = Util.formatSlide(res.body)

            this.setSlide(res.body)
            this.dataSlideNext = null
            return true
          })
          .catch((err) => {
            _handleGetSlideData()
            if (Sentry && err.status) {
              err.from = 'Audience get next slide'
              Sentry.captureException(JSON.stringify(err))
            }
          })
      } else {
        _handleGetSlideData()
      }

      this.dataSlideNext = null
    },

    tryParseBody(text, presentationId) {
      // This function to fix AHA-116
      // TODO: Remove this sometime later
      const rawText = Util.decrypt(text, presentationId)
      try {
        return JSON.parse(rawText)
      } catch (SyntaxError) {
        return JSON.parse(decodeURIComponent(rawText))
      }
    },

    _hanldeAudienceGetPresentation(res) {
      if (res.body.limitOnline) {
        if (res.body.message) {
          this.limitOnline = res.body.message
        } else {
          this.limitOnline =
            'This presentation has reached the max capacity allowed. To join in, please ask your presenter to upgrade their account to a bigger plan.'
        }
        this.isLoading = false
        return
      }

      res.body = Util.formatSlide(res.body)
      this._clearDataSlide(res.body)
      this.subscribeSlideChangeAction({
        editor: this,
        presentation: res.body.presentation,
      })
      this.syncQuizStageAction(res.body.presentation.id)
      this.subscribeLeaderboardVisibilityAction({ presentation: res.body.presentation })

      if (res.body.presentation.audiencePacing) {
        this.getSlideList(res.body.presentation.id)
      } else {
        window.history.replaceState(null, null, ' ')
        setTimeout(() => {
          this.isLoading = false
        }, 500)
      }
      this.setPresentationAction(res.body.presentation)
      this.setSlide(res.body)
      if (!res.body.presentation) {
        res.body.presentation = {}
      } else if (
        this.uniqueAccessCode !== res.body.presentation.uniqueAccessCode
      ) {
        this.$router.replace({
          name: 'presentation',
          query: this.$route.query,
          params: { id: res.body.presentation.uniqueAccessCode },
        })
      }

      this.uniqueAccessCode = res.body.presentation.uniqueAccessCode

      if (res.body.presentation && !res.body.presentation.language) {
        res.body.presentation.language = 'en'
      }
      this.$store.dispatch('setLang', res.body.presentation.language)
      if (
        res.body.presentation.fontFamily &&
        res.body.presentation.fontFamily != 'Plus Jakarta Sans'
      ) {
        Util.setFontSlideV2(res.body.presentation.fontFamily)
      }
      this.$store.state.logo = res.body.presentation.logo

      socket.init(() => {
        PresentationSocketHandlerV2.handleInitSocket(res, this)
      }, this.uniqueAccessCode.toLowerCase(), this.audienceId)

      // get audienceQuizTeam
      const audienceQuizTeam = storage.getValueByPresentation(this.$store.state.presentation.id, 'audienceQuizTeam')
      if (audienceQuizTeam) {
        if (this.$store.state.presentation.teamPlay) {
          const index = this.$store.state.presentation.teamData.filter((item) => {
            return item.id === audienceQuizTeam && item.visible
          })
          if (index !== -1) {
            this.$store.state.audienceQuizTeam = audienceQuizTeam
          }
        }
      }

      if (res.body.presentation && !res.body.presentation.privateMode && this.audienceId) {
        // Chỉ ghi nhận participant nếu presentation ở PUBLIC mode
        this.trackAudienceJoinPresentation(this.audienceId, res.body.presentation.id)
      }
      this.checkAudienceAuthentication()
    },

    async checkAudienceAuthentication() {
      setTimeout(async () => {
        const { planType, isAudienceAuthentication } = this.presentation
        if (isAudienceAuthentication && this.authenticationCode && (planType === 'pro-yearly' || planType === 'pro-monthly' || planType === 'one-time-large' || planType === 'white-label')) {
          try {
            await this.$http.post(Config.api.audienceCheckAuthentication, {
              uniqueAccessCode: this.presentation.uniqueAccessCode,
              authenticationCode: this.authenticationCode,
              audienceId: this.audienceId,
            })
          } catch (error) {
            Sentry.captureException(error)
            this.$store.state.authenticationCode = ''
            storage.setValueByPresentation(
              this.presentation.id,
              'authenticationCode',
              '',
            )
          }
        }
      }, 1000)
    },

    async trackAudienceJoinPresentation(audienceId, presentationId) {
      // get current user
      const dataAudience = {
        audienceId,
        presentationId,
      }
      if (this.currentUser && this.currentUser.email) {
        dataAudience.email = this.currentUser.email
      }
      this.createOrUpdateAudienceAction(dataAudience)
      storage.updateValueByPresentation(presentationId, 'audienceId', audienceId)
    },
    async _handleDataReconnect(res) {
      const { quizStatus } = this.slideActive
      res.body = Util.formatSlide(res.body)
      if (res.body.limitOnline || res.body.presentation.audiencePacing) {
        window.location.reload()
        return
      }
      if (res.body.id == this.slideActive.id) {
        // DEBUG AHA-6742
        try {
          if (res.body.slideTimestamp < this.slideActive.slideTimestamp) {
            Sentry.captureException(new Error('DEBUG AHA-6742: Returned slide is older than current'))
          }

          if (res.body.quizTimestamp.length == 0 && this.slideActive.quizTimestamp > 0) {
            Sentry.captureException(new Error('DEBUG AHA-6742: quizTimestamp was removed'))
          }
        } catch (err) {
          Sentry.captureException(err)
        }
        // END OF DEBUG
        const self = this
        const _compareData = function () {
          let count = 0
          for (let i = 0; i < res.body.SlideOptions.length; i++) {
            for (
              let j = 0;
              j < self.slideActive.SlideOptions.length;
              j++
            ) {
              if (
                self.slideActive.SlideOptions[j].id ==
                res.body.SlideOptions[i].id
              ) {
                res.body.SlideOptions[i].selected =
                  self.slideActive.SlideOptions[j].selected
                res.body.SlideOptions[i].disable =
                  self.slideActive.SlideOptions[j].disable

                if (res.body.SlideOptions[i].selected) {
                  count++
                }
                if (count > res.body.limitChoice) {
                  res.body.SlideOptions[i].selected = false
                  res.body.SlideOptions[i].disable = true
                } else {
                  res.body.SlideOptions[i].disable = false
                }
                break
              }
            }
          }
          res.body.radioSelectded = self.slideActive.radioSelectded
          return res.body
        }
        if (
          this.slideActive.id == res.body.id
          && this.slideActive.type === 'pickAnswer'
          && quizStatus < 4
          && res.body.quizStatus == QuizStatuses.QUESTION_SCREEN
          && res.body.quizTimestamp
          && res.body.quizTimestamp.length
        ) {
          this.$store.state.countdownTimeToAnswer = res.body.timeToAnswer
          this.slideActive.quizTimestamp = res.body.quizTimestamp
          EventBus.$emit('start-countdown-pick-answer')
        }
        this.$store.dispatch('setSlide', _compareData())
      } else {
        this.dataSlideNext = res.body
        this.confirmNextSlide()
      }

      if (
        this.slideActive.type === 'spinnerWheel' || this.slideActive.type === 'qrcode'
        || (this.slideActive.type === 'pickAnswer' && this.slideActive.quizStatus == QuizStatuses.LOBBY_SCREEN)
      ) {
        const data = {
          a: this.audienceId,
          c: this.$store.state.presentation.uniqueAccessCode,
          n: this.$store.state.audienceName,
          e: this.$store.state.audienceEmoji,
          t: this.$store.state.audienceQuizTeam,
        }

        try {
          await this.$http.post(joinPresentationUtils.getApiUrlJoinPresentation(), data)
        } catch (error) {
          Sentry.captureException(error)
        }
      }
    },

    async decryptSlide(doc, slideId) {
      try {
        return this.tryParseBody(doc.data, doc.socketId)
      } catch (error) {
        sentry.captureException('Cannot decrypt socket slide data', { extra: { doc } })
      }

      try {
        const res = await this.$http.get(Config.api.getNextSlide + slideId)
        return Util.formatSlide(res.body)
      } catch (error) {
        Sentry.captureException(error)
      }

      return {}
    },

    handleResetData(doc) {
      if (!doc) {
        return
      }
      let presentation = doc
      if (doc.presentation) {
        presentation = doc.presentation
      }

      if (!presentation.resetTimeStamp) {
        return
      }

      const {
        id: presentationId,
        resetTimeStamp: newResetTimeStamp,
      } = presentation

      try {
        const oldResetTimeStamp = storage.getValueByPresentation(presentationId, 'resetTimeStamp')

        if (oldResetTimeStamp !== newResetTimeStamp) {
          storage.clearValueByPresentation(presentationId)
          storage.setValueByPresentation(presentationId, 'resetTimeStamp', newResetTimeStamp)
        }
      } catch (error) {
        Sentry.captureException(error)
      }
    },

    _updateQuestionAnswer(question) {
      const index = this.$store.state.questions.findIndex((item) => {
        return item.id == question.id
      })
      if (index === -1) {
        this.$store.state.questions.push(question)
      } else {
        this.$store.state.questions[index] = question
      }
      const arr = JSON.parse(JSON.stringify(this.$store.state.questions))
      Util.updateDataQuestionAnswer(arr, this.$store.state.tabQnaQuestion)
    },

    _isStorageAnswerIdOutdated(
      presentationId,
      presentationResetTimeStamp,
      slideResetTimeStamp,
    ) {
      const msSlideResetTimeStamp = new Date(slideResetTimeStamp).getTime()

      if (presentationResetTimeStamp && presentationResetTimeStamp > msSlideResetTimeStamp) return true

      const storageUpdatedAt = storage.getValueByPresentation(presentationId, 'updatedAt', 0)
      const msStorageUpdatedAt = storageUpdatedAt * 1000

      if (msStorageUpdatedAt < msSlideResetTimeStamp) return true

      return false
    },

    _clearDataSlide(slide) {
      const { resetTimeStamp, id: slideId, presentationId } = slide

      const alreadyClearedDataSlides = storage.getValueByPresentation(presentationId, 'alreadyClearedDataSlides', [])
      const matchSlide = alreadyClearedDataSlides.find((item) => item.slideId === slideId) || {}

      if (!resetTimeStamp || resetTimeStamp === matchSlide.resetTimeStamp) return
      const { resetTimeStamp: presentationResetTimeStamp } = this.$store.state.presentation

      if (!this._isStorageAnswerIdOutdated(
        presentationId,
        presentationResetTimeStamp,
        resetTimeStamp,
      )) return
      // clear answered multiple choice questions
      const oldAnsweredSlideIds = storage.getValueByPresentation(presentationId, 'answeredSlideIds', [])
      const newAnsweredSlideIds = oldAnsweredSlideIds.filter((item) => slideId !== item)

      if (oldAnsweredSlideIds.length !== newAnsweredSlideIds.length) {
        storage.setValueByPresentation(presentationId, 'answeredSlideIds', newAnsweredSlideIds)
      }

      // update resetTimeStamp to storage for future checks
      const newAlreadyClearedDataSlides = alreadyClearedDataSlides.filter((item) => {
        return item.slideId !== slideId
      })
      newAlreadyClearedDataSlides.push({ slideId, resetTimeStamp })
      storage.setValueByPresentation(presentationId, 'alreadyClearedDataSlides', newAlreadyClearedDataSlides)

      // clear data multiplechoice & image choice by slide Id
      const answeredSlides = storage.getValueByPresentation(presentationId, 'answeredSlides', {})
      if (answeredSlides[slideId]) {
        delete answeredSlides[slideId]
        storage.setValueByPresentation(presentationId, 'answeredSlides', answeredSlides)
      }
    },

    // Don't change images when image name is not changed

    getSlideList(id, fromSocket) {
      this.$store.state.idSlide = null
      this.$store.state.slides = []
      this.$http.get(Config.api.listSlide + id).then(
        (res) => {
          this.$store.state.slides = res.body
          this.isLoading = false
          if (!fromSocket) {
            const currentSlideIndex = Util.getCurrentSlideIndexFromUrl()
            const isPresentationVisited = storage.getValueByPresentation(this.presentation.id, 'visited', false)
            // If slide index doesnt exist, or it's the very first time audience access this presentation
            // -> Redirect them to the first slide
            if (currentSlideIndex === 0 || !isPresentationVisited) {
              const path = `${window.location.pathname}#1`
              window.history.pushState({}, PAGE_TITLE, path)
            }
            if (!currentSlideIndex) {
              this.$store.state.idSlide = res.body[0].id
              this.confirmNextSlide()
            } else {
              this.checkAudiencePacing()
            }
          } else {
            this.$store.state.idSlide = JSON.parse(
              JSON.stringify(this.slideActive.id),
            )

            const index = this.$store.state.slides.findIndex((item) => {
              return item.id == this.$store.state.idSlide
            })

            if (index !== -1) {
              const path = `${window.location.pathname}#${index + 1}`
              window.location.href = path
              window.location.reload()
            }
          }
          storage.setValueByPresentation(this.presentation.id, 'visited', true)
        },
        () => {},
      )
    },

    handleDataQuestions(doc) {
      if (this.enableForBigEvent) return
      if (doc) {
        const query = {
          isAudience: true,
          audience: this.audienceId,
          id: doc.id,
        }

        if (doc.qnaAudienceShowAll) {
          query.qnaAudienceShowAll = true
        }
        this.$http
          .get(Config.api.listQuestion, {
            params: query,
          })
          .then(
            (res) => {
              const arr = JSON.parse(JSON.stringify(res.body))
              Util.updateDataQuestionAnswer(
                arr,
                this.$store.state.tabQnaQuestion,
              )
            },
            () => {},
          )
      }
    },

    hideQASession() {
      this.$store.state.showQaSession = false
      Util.mixpanelTrack(
        'Question And Answer',
        'Audience',
        'Close Ask a question popup',
      )
    },

    hideFeedbackForm() {
      this.$store.state.showFeedbackForm = false
    },

    hideRequestPresentation() {
      this.$store.state.showRequestPresentation = false
      Util.mixpanelTrack(
        'Audience', 'Request presentation overlay > Click',
      )
    },

    _checkSubmited() {
      const { id, type } = this.slideActive
      const presentationId = this.$store.state.presentation.id
      const answeredSlideIds = storage.getValueByPresentation(presentationId, 'answeredSlideIds', [])
      const lastSlideId = this.$store.state.presentation.lastSlide
      if (answeredSlideIds.includes(id)) {
        if (lastSlideId === id) {
          if (type === 'openEnded' || type === 'wordCloud') {
            if (!this.slideActive.openEndedMultipleOption) {
              this.slideActive.isEndSlide = true
              this.$store.dispatch('updateSlide', this.slideActive)
            }
          } else if (type === 'multipleChoice' || type === 'imageChoice' || type === 'scale') {
            this.slideActive.isEndSlide = true
            this.$store.dispatch('updateSlide', this.slideActive)
          }
        }
      }
    },

    _handleAudienceAdmissionDataFromSocket(dataFromSocket) {
      const { presentation } = this.$store.state
      if (!presentation.audienceAdmission) presentation.audienceAdmission = {}
      presentation.disableFormJoinPresentation = false

      presentation.audienceAdmission.heading = dataFromSocket.audienceAdmission.heading

      presentation.audienceAdmission.isAudienceAdmission =
        dataFromSocket.audienceAdmission.isAudienceAdmission

      this._setPresentationAudienceAdmissionField(presentation,
        dataFromSocket.audienceAdmission.fields)
    },

    _setPresentationAudienceAdmissionField(presentation, fieldsFromSocket) {
      const hasFields = presentation.audienceAdmission && presentation.audienceAdmission.fields
      if (!hasFields) return
      const oldFields = [...presentation.audienceAdmission.fields]
      const oldFieldsHasText = oldFields.some((field) => field.data && field.data.length)
      presentation.audienceAdmission.fields = Util.formatFields(fieldsFromSocket)
      // If has value on input => keep that value
      if (oldFieldsHasText) {
        oldFields.forEach((oldField) => {
          const index = presentation.audienceAdmission.fields.findIndex(
            (field) => field.type === oldField.type,
          )
          if (index !== -1) {
            presentation.audienceAdmission.fields[index].data = oldField.data
          }
        })
      }
    },

    handleSlideOption: _throttle(function throttleResultSlideOption(doc) {
      if (this.slideActive.id !== doc.slideId) return
      const { SlideOptions } = this.slide
      let totalVoteCount = 0
      SlideOptions.forEach((item) => {
        if (!item.votesCount) item.votesCount = 0
        const index = doc.slideOptions.findIndex((op) => {
          return op.id == item.id
        })
        if (index !== -1) {
          item.votesCount = doc.slideOptions[index].votesCount
        }
        totalVoteCount += item.votesCount
      })

      if (this.slideActive.showPercentage) {
        try {
          SlideOptions.forEach((item) => {
            item.votesCountValue = Number(`${Math.round(`${(item.votesCount / totalVoteCount) * 100}e1`)}e-1`)
          })
        } catch (error) {
          Sentry.captureException(error)
          SlideOptions.forEach((item) => {
            item.votesCountValue = item.votesCount
          })
        }
      } else {
        SlideOptions.forEach((item) => {
          item.votesCountValue = item.votesCount
        })
      }

      this.$store.dispatch('updateSlide', {
        SlideOptions,
      })
    }, 600),

    async sendRequestUpdateTimeAudience() {
      setTimeout(async () => {
        try {
          await this.$http.post(Config.api.updateTimeAudience, {
            presentationId: this.$store.state.presentation.id,
            audienceId: this.audienceId,
          })
        } catch (error) {
          Sentry.captureException(error)
        }
      }, Math.random() * 30 * 1000)
    },

    handleSlideIdChange(slideId) {
      if (!slideId && !this.slides.length) return

      const index = this.slides.findIndex((item) => {
        return item.id == slideId
      })

      if (index !== -1) {
        this.setSlideIndexAction({
          index,
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";

.qna-button-show {
  text-align: center;
  padding: 0 16px;
}

.overlay-qna {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.box-qna-session {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #00000050;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  z-index: 999;
  padding: 0 10px;
  padding-top: 140px;

  @media (max-width: 400px) {
    padding-left: 0;
    padding-right: 0;
  }
}

.box-request-presentation {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #00000050;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  z-index: 999;
  padding: 0 10px;

  @media (max-width: 400px) {
    padding-left: 0;
    padding-right: 0;
  }
}

.link-reload {
  cursor: pointer;
}

.waiting-next-slide {
  padding: 16px;
  text-align: center;

  .title {
    font-weight: bold;
    margin-top: 24px;
    margin-bottom: 8px;
  }

  .desp {
    color: #555;
    margin-bottom: 12px;
  }

  .fa-lg {
    font-size: 5.333333em;
    color: $primary-color;
  }
}

.loading-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  z-index: 50;

  & ::v-deep .spinner {
    width: 210px;

    & > div {
      width: 30px;
      height: 30px;
    }
  }
}

.content-presentation {
  max-width: 710px;
  margin: 0 auto;
  padding: 0 0 24px 0;
  ::v-deep .text-hyper-link {
    text-decoration: underline;
    opacity: 0.8;
    word-break: break-all;
    &:hover {
      opacity: 1;
      text-decoration: underline !important;
      color: inherit !important;
    }
  }
  &.is-content-slide {
  max-width: 840px;

  }
}

.confirm-next-slide {
  position: fixed;
  top: -100%;
  left: 0;
  width: 100%;
  background-color: #fff;
  text-align: center;
  padding: 16px 0;
  transition: all 0.5s ease;
  border-bottom: 1px solid #ddd;
  z-index: 200;
  color: #313131;

  &.connection-lost {
    z-index: 300;
  }

  .text {
    margin-bottom: 10px;
    font-weight: bold;
  }

  button {
    margin: 0 5px;
  }

  &.active {
    top: 0;
  }
}

.no-data {
  padding: 16px;
}

.btn-signup {
  a {
    display: block;
    margin: 16px 0;
    text-decoration: none;
  }
}

.text-exit {
  color: $primary-color;
  cursor: pointer;
  &:hover {
    color: $primary-hover-color;
  }
}

.audience-pacing {
  text-align: center;
  font-size: 18px;
  margin-top: 16px;
  padding: 0 16px;

  a {
    cursor: pointer;
  }
}

.presentation {
  &.white {
    & ::v-deep .default-logo {
      display: none;
    }
    & ::v-deep .white-logo {
      display: block;
    }

    & ::v-deep .footer {
      a {
        color: #fff;
        text-decoration: underline;
      }
    }

    & ::v-deep .input-wrapper {
      background-color: #00000040;
    }

    & ::v-deep .text-exit {
      color: #fff;
      text-decoration: underline;
    }

    & .audience-pacing {
      a {
        color: #fff;
        text-decoration: underline;
      }
    }

    & ::v-deep .change-team {
      color: #fff;
    }
  }

  & ::v-deep .content-bulletpoint {
    .audio-control-slide {
      text-align: center;
    }
  }
}
.private-mode{
  color : #4f9af2;
}
.slide-text-left {
  & ::v-deep {
    .slide-title-style, .title-desc, .subheading-bulletPoints, .no-result-yet-text, .subheading, .bullet-list-item {
      text-align: left;
    }
    .audio-control-slide {
      text-align: left !important;
    }

    .fix-content-leaderboard {
      text-align: left;
    }
  }
}

.slide-text-right {
  & ::v-deep {
    .slide-title-style, .title-desc, .subheading-bulletPoints, .no-result-yet-text, .subheading, .bullet-list-item {
      text-align: right;
    }
    .audio-control-slide {
      text-align: right !important;
    }
    .bullet-list-item {
      direction: rtl;
    }
    .fix-content-leaderboard {
      text-align: right;
    }
  }
}

.slide-text-center {
  & ::v-deep {
    .slide-title-style, .title-desc, .subheading-bulletPoints, .no-result-yet-text, .subheading {
      text-align: center;
    }
    .audio-control-slide {
      text-align: center !important;
    }
  }
}
.try-to-reload {
  display: flex;
  justify-content: center;
  margin: 16px 0;
  .link-reload {
    margin: 0 0 0 0.25rem;
  }
}
.aha-footer__live-chat{
  position: fixed;
  right: 1rem;
  bottom: 0.5rem;
  z-index: 100;
}
.live-chat__wrapper {
  position: absolute;
  right: 1rem;
  bottom: 0;
  z-index: 10;
  & ::v-deep {
    .chat-box__tip {
      top: -19px;
      right: 2.5rem;
      left: unset;
    }
    .chat-box__header-close-icon {
      margin-top: 8px;
    }
  }
  @media (max-width : 300px) {
    display: none;
  }

}

@media (max-width: 767px) {
  .live-chat__wrapper {
    right: 0.5rem;
  & ::v-deep {
    .chat-toggle__title {
      display: none;
    }
    .chat-box__tip {
      right: 0.5rem;
      top: -20px;
    }
    .chat-toggle--pill {
      padding: 7px 9px 4px 13px;
    }
  }
}
}

.tabs-content.tabs-content-hackathon, .hackathon-slide {
  height: 100%;
}
.reaction-hackathon {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 16px;
}
</style>
